import { GET_PARTICIPATION_LIST } from "../types";

const initialState = {
  dealers: [],
  total: 0,
};

export default function participantsReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_PARTICIPATION_LIST:
      return {
        ...state,
        dealers: payload.data,
        total: payload.total,
      };

    default:
      return state;
  }
}
